export default {
  "pages.layouts.userLayout.title":
    "Ant Design is the most influential web design specification in Xihu district",
  "pages.login.accountLogin.tab": "Account Login",
  "pages.login.accountLogin.errorMessage": "Incorrect username/password",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.success": "Login successful!",
  "pages.login.username.placeholder": "Username: admin or user",
  "pages.login.username.required": "Please input your username!",
  "pages.login.password.placeholder": "Password: ant.design",
  "pages.login.password.required": "Please input your password!",
  "pages.login.phoneLogin.tab": "Phone Login",
  "pages.login.phoneLogin.errorMessage": "Verification Code Error",
  "pages.login.phoneNumber.placeholder": "Phone Number",
  "pages.login.phoneNumber.required": "Please input your phone number!",
  "pages.login.phoneNumber.invalid": "Phone number is invalid!",
  "pages.login.captcha.placeholder": "Verification Code",
  "pages.login.captcha.required": "Please input verification code!",
  "pages.login.phoneLogin.getVerificationCode": "Get Code",
  "pages.getCaptchaSecondText": "sec(s)",
  "pages.login.rememberMe": "Remember me",
  "pages.login.forgotPassword": "Forgot Password ?",
  "pages.login.submit": "Login",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage":
    "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "Enquiry Form",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "batch deletion",
  "pages.searchTable.batchApproval": "batch approval",

  // ========== Common Translations ==========
  // Buttons
  "button.search": "Search",
  "button.reset": "Reset",
  "button.edit": "Edit",
  "button.delete": "Delete",
  "button.remembered": "I Remembered",
  "button.common.edit": "Edit",
  "button.common.delete": "Delete",
  "button.common.more": "More",
  "button.common.close": "Close",

  // Messages
  "message.loading": "Loading",
  "message.noData": "No Data",
  "message.createSuccess": "Created Successfully",
  "message.createFailed": "Creation Failed",
  "message.updateSuccess": "Updated Successfully",
  "message.updateFailed": "Update Failed",
  "message.deleteSuccess": "Deleted Successfully",
  "message.deleteFailed": "Deletion Failed",
  "message.password.safeguard":
    "Please keep the password safe. It is recommended to change it after first login.",

  // Status
  "status.enabled": "Enabled",
  "status.disabled": "Disabled",

  // Boolean
  "boolean.yes": "Yes",
  "boolean.no": "No",
  "boolean.bound": "Bound",
  "boolean.unbound": "Unbound",

  // Business Status
  "business.open": "Open",
  "business.closed": "Closed",

  // Labels
  "label.initialPassword": "Initial Password",
  "label.phone": "Phone",

  // Common
  "common.unknown": "Unknown",

  // Common Table Columns
  "table.common.status": "Status",
  "table.common.createdAt": "Created At",
  "table.common.updatedAt": "Updated At",
  "table.common.action": "Action",
  "table.common.actions": "Actions",
  "table.common.sortOrder": "Sort Order",
  "table.common.brandName": "Brand Name",
  "table.common.storeName": "Store Name",
  "table.common.phone": "Phone",
  "table.common.email": "Email",
  "table.common.role": "Role",

  // Common Form Fields
  "form.common.status": "Status",
  "form.common.sortOrder": "Sort Order",
  "form.common.phone": "Phone",
  "form.common.email": "Email",
  "form.common.note": "Note",
  "form.common.account": "Account",
  "form.common.password": "Password",

  // Common Validations
  "validation.status.required": "Please select status",
  "validation.phone.required": "Please enter phone number",
  "validation.phone.invalid": "Please enter a valid phone number",
  "validation.email.invalid": "Please enter a valid email address",
  "validation.common.phoneFormat": "Please enter a valid phone number format",
  "validation.common.statusRequired": "Please select status",

  // Common Placeholders
  "form.placeholder.input": "Please enter",
  "form.placeholder.select": "Please select",
  "component.placeholder.select": "Please select",
  "component.placeholder.input": "Please enter",
  "component.placeholder.noData": "No data",
  "placeholder.phone": "Please enter phone number",
  "placeholder.email": "Please enter email",
  "placeholder.common.startDate": "Start date",
  "placeholder.common.endDate": "End date",

  // Pagination
  "pagination.total": "Total {total} items",

  // Filter
  "filter.all": "All",
  "filter.bound": "Bound",
  "filter.unbound": "Unbound",

  // ========== Brand Management ==========
  "button.brand.create": "Create Brand",
  "error.brand.loadListFailed": "Failed to load brand list",
  "error.brand.deleteFailed": "Failed to delete brand",
  "error.brand.operationFailed": "Brand operation failed",
  "table.brand.brandName": "Brand Name",
  "table.brand.contactName": "Contact Name",
  "table.brand.contactPhone": "Contact Phone",
  "modal.brand.deleteTitle": "Delete Brand",
  "modal.brand.deleteContent": "Are you sure you want to delete this brand?",
  "modal.brand.updateTitle": "Edit Brand",
  "modal.brand.createTitle": "Create Brand",
  "message.brand.createSuccessDetail":
    "Brand created successfully! Below is the admin account information, please keep it safe:",
  "message.brand.passwordGenerated":
    "Password generated for admin account, please keep it safe:",
  "message.brand.passwordWarning":
    "Warning: Password is shown only once, please save it immediately!",
  "form.brand.brandName": "Brand Name",
  "form.brand.contactName": "Contact Name",
  "form.brand.contactPhone": "Contact Phone",
  "form.brand.adminPhone": "Admin Phone",
  "form.brand.adminName": "Admin Role Name",
  "form.brand.adminNameTooltip":
    'The name for this admin in the brand admin role, e.g., "Mr. Zhang"',
  "validation.brand.nameRequired": "Please enter brand name",
  "validation.brand.contactNameRequired": "Please enter contact name",
  "validation.brand.contactPhoneRequired": "Please enter contact phone",
  "validation.brand.adminPhoneRequired": "Please enter admin phone",
  "placeholder.brand.name": "Please enter brand name",
  "placeholder.brand.contactName": "Please enter contact name",
  "placeholder.brand.adminPhone": "Please enter admin phone",
  "placeholder.brand.adminName": "Enter admin role name (optional)",

  // ========== Store Management ==========
  "button.store.create": "Create Store",
  "button.store.subMerchantConfig": "Merchant Config",
  "error.store.loadListFailed": "Failed to load store list",
  "error.store.deleteFailed": "Failed to delete store",
  "error.store.operationFailed": "Store operation failed",
  "table.store.brandId": "Brand ID",
  "table.store.brandName": "Brand Name",
  "table.store.storeName": "Store Name",
  "table.store.province": "Province",
  "table.store.city": "City",
  "table.store.district": "District",
  "table.store.address": "Address",
  "table.store.contactPhone": "Contact Phone",
  "table.store.businessStatus": "Business Status",
  "modal.store.deleteTitle": "Delete Store",
  "modal.store.deleteContent": "Are you sure you want to delete this store?",
  "modal.store.updateTitle": "Edit Store",
  "modal.store.createTitle": "Create Store",
  "message.store.createSuccessTitle": "Store Created Successfully",
  "message.store.createSuccessDetail":
    "Store has been created successfully. Below is the admin account information, please keep it safe:",
  "message.store.passwordWarning":
    "Warning: Password is shown only once, please save it immediately!",
  "form.store.brandId": "Brand",
  "form.store.brandIdTooltip": "Platform admin must specify a brand",
  "form.store.name": "Store Name",
  "form.store.region": "Region",
  "form.store.address": "Address",
  "form.store.longitude": "Longitude",
  "form.store.latitude": "Latitude",
  "form.store.contactPhone": "Contact Phone",
  "form.store.businessStatus": "Business Status",
  "form.store.adminPhone": "Admin Phone",
  "form.store.adminPhoneTooltip":
    "If the phone number does not exist, the system will automatically create a new account",
  "form.store.adminName": "Admin Role Name",
  "form.store.adminNameTooltip":
    'The name for this admin in the store admin role, e.g., "Zhang San"',
  "validation.store.brandIdRequired": "Please select brand",
  "validation.store.nameRequired": "Please enter store name",
  "validation.store.regionRequired": "Please select region",
  "validation.store.addressRequired": "Please enter address",
  "validation.store.longitudeRequired": "Please enter longitude",
  "validation.store.latitudeRequired": "Please enter latitude",
  "validation.store.contactPhoneRequired": "Please enter contact phone",
  "validation.store.businessStatusRequired": "Please select business status",
  "validation.store.adminPhoneRequired": "Please enter admin phone",
  "placeholder.store.name": "Please enter store name",
  "placeholder.store.address": "Please enter address",
  "placeholder.store.longitude": "Please enter longitude",
  "placeholder.store.latitude": "Please enter latitude",
  "placeholder.store.contactPhone": "Please enter contact phone",
  "placeholder.store.adminPhone": "Please enter admin phone",
  "placeholder.store.adminName": "Enter admin role name (optional)",

  // ========== Menu Management ==========
  "button.menu.create": "Create Menu",
  "button.menu.bindPermission": "Bind Permission",
  "error.menu.loadTreeFailed": "Failed to load menu tree",
  "error.menu.loadListFailed": "Failed to load menu list",
  "error.menu.deleteFailed": "Failed to delete menu",
  "error.menu.operationFailed": "Menu operation failed",
  "error.menu.loadParentFailed": "Failed to load parent menu",
  "menu.tree.all": "All Menus",
  "menu.tree.title": "Menu Directory",
  "table.menu.menuCode": "Menu Code",
  "table.menu.menuName": "Menu Name",
  "table.menu.path": "Menu Path",
  "table.menu.component": "Component Path",
  "table.menu.icon": "Menu Icon",
  "table.menu.menuType": "Menu Type",
  "table.menu.sortOrder": "Sort Order",
  "menu.type.pc": "PC",
  "menu.type.miniProgram": "Mini Program",
  "menu.type.pos": "POS",
  "modal.menu.deleteTitle": "Delete Menu",
  "modal.menu.deleteContent": "Are you sure you want to delete this menu?",
  "modal.menu.updateTitle": "Edit Menu",
  "modal.menu.createTitle": "Create Menu",
  "form.menu.menuCode": "Menu Code",
  "form.menu.menuName": "Menu Name",
  "form.menu.path": "Route Path",
  "form.menu.component": "Component Path",
  "form.menu.parentId": "Parent Menu",
  "form.menu.noParent": "None (Top Level)",
  "form.menu.icon": "Menu Icon",
  "form.menu.menuType": "Menu Type",
  "form.menu.sortOrder": "Sort Order",
  "form.menu.roleLevels": "Applicable Role Levels",
  "form.menu.description": "Menu Description",
  "validation.menu.menuCodeRequired": "Please enter menu code",
  "validation.menu.menuNameRequired": "Please enter menu name",
  "validation.menu.parentIdRequired": "Please select parent menu",
  "validation.menu.menuTypeRequired": "Please select menu type",
  "validation.menu.roleLevelsRequired": "Please select applicable role levels",
  "validation.menu.sortOrderRequired": "Please enter sort order",
  "placeholder.menu.name": "Please enter menu name",
  "placeholder.menu.menuName": "Please enter menu name",
  "placeholder.menu.menuCode": "Please enter menu code, e.g.: brand_list",
  "placeholder.menu.path": "Please enter route path, e.g.: /brand/list",
  "placeholder.menu.component": "Please enter component path, e.g.: BrandList",
  "placeholder.menu.parentId": "Please select parent menu",
  "placeholder.menu.icon": "Please enter menu icon, e.g.: list",
  "placeholder.menu.description": "Please enter menu description",
  "placeholder.menu.sortOrder":
    "Please enter sort order, smaller numbers come first",
  "message.menu.posOnlyForStore":
    "POS menu is only applicable to store administrators",
  "tooltip.menu.posRoleLevels": "POS menu is fixed to store level",
  "tooltip.menu.posPath":
    "POS menu path can be empty (only for permission control)",

  // ========== Permission Management ==========
  "error.permission.loadBoundFailed": "Failed to load bound permissions",
  "error.permission.loadListFailed": "Failed to load permission list",
  "error.permission.bindFailed": "Failed to bind permissions",
  "message.permission.bindSuccess": "Permissions bound successfully",
  "message.permission.bindFailed": "Failed to bind permissions",
  "table.permission.bindStatus": "Bind Status",
  "table.permission.permCode": "Permission Code",
  "table.permission.permName": "Permission Name",
  "table.permission.permType": "Permission Type",
  "table.permission.apiPath": "API Path",
  "table.permission.httpMethod": "HTTP Method",
  "permission.type.menu": "Menu",
  "permission.type.button": "Button",
  "permission.type.api": "API",
  "modal.permission.title": "Menu Permission Binding (Menu ID: {menuId})",
  "modal.permission.alertTitle": "Operation Info",
  "modal.permission.alertDescription":
    "Select permissions to bind to this menu. This will replace all existing permission bindings. Currently selected {selected} permissions (initially bound {initial}).",
  "placeholder.permission.search":
    "Search by permission code, name, API path...",

  // ========== Role Management ==========
  "button.role.create": "Create Role",
  "error.role.getDetailsFailed": "Failed to load role details",
  "table.role.roleName": "Role Name",
  "table.role.roleCode": "Role Code",
  "table.role.description": "Role Description",
  "table.role.roleLevel": "Role Level",
  "table.role.isPublic": "Is Public Role",
  "role.level.platform": "Platform Admin",
  "role.level.brand": "Brand Admin",
  "role.level.store": "Store Admin",
  "role.level.fund": "Fund Account",
  "role.systemDefault": "System Default",
  "modal.role.deleteTitle": "Delete Role",
  "modal.role.deleteConfirm":
    "Are you sure you want to delete this role? Please ensure no users are using this role.",
  "modal.role.editTitle": "Edit Role",
  "modal.role.createTitle": "Create Role",
  "form.role.roleName": "Role Name",
  "form.role.roleCode": "Role Code",
  "form.role.roleLevel": "Role Level",
  "form.role.isPublic": "Is Public Role",
  "form.role.isPublic.tooltip":
    "Public roles can be used by all brands and stores, usually created by platform administrators",
  "form.role.roleCode.tooltip":
    "System preset field for identifying public roles (e.g., PLATFORM_ADMIN, BRAND_ADMIN), optional",
  "form.role.description": "Role Description",
  "form.role.assignPermissions": "Assign Permissions",
  "validation.role.nameRequired": "Please enter role name",
  "validation.role.codeRequired": "Please enter role code",
  "validation.role.roleLevelRequired": "Please select role level",
  "validation.role.permissionsRequired":
    "Please select at least one permission",
  "validation.role.menuRequired": "Please select at least one menu permission",
  "placeholder.role.roleName": "Please enter role name",
  "placeholder.role.roleCode": "Please enter role code, e.g.: BRAND_ADMIN",
  "placeholder.role.roleCode.optional": "Optional, leave blank if not needed",
  "placeholder.role.roleLevel": "Please select role level",
  "placeholder.role.description": "Please enter role description",
  "placeholder.role.selectPermissions": "Please select permissions",
  "message.role.posMenuInfo":
    "POS Menu: For POS application permission control, only available to store administrators",

  // ========== Public Role Management ==========
  "button.publicRole.create": "Create Public Role",
  "error.publicRole.getDetailsFailed": "Failed to load public role details",
  "modal.publicRole.deleteTitle": "Delete Public Role",
  "modal.publicRole.deleteConfirm":
    "Are you sure you want to delete this public role? Please ensure no users are using this role.",
  "modal.publicRole.editTitle": "Edit Public Role",
  "modal.publicRole.createTitle": "Create Public Role",
  "message.publicRole.info":
    "Public roles can be used by all brands and stores. They are platform-level roles by default and do not require brand or store selection.",
  "message.publicRole.selectRoleLevelFirst":
    "Please select the role level first, the system will filter available menus based on the level",
  "placeholder.publicRole.roleName": "Please enter public role name",
  "placeholder.publicRole.roleCode":
    "Please enter role code, e.g.: PUBLIC_CASHIER",
  "placeholder.publicRole.description": "Please enter public role description",
  "form.publicRole.roleLevel": "Role Level",
  "validation.publicRole.roleLevelRequired": "Please select role level",
  "table.publicRole.roleLevel": "Role Level",
  "roleLevel.platform": "Platform Role",
  "roleLevel.brand": "Brand Role",
  "roleLevel.store": "Store Role",
  "roleLevel.fund": "Fund Account",

  // ========== Admin Management ==========
  "button.admin.create": "Create Admin",
  "modal.admin.deleteTitle": "Delete Admin",
  "modal.admin.deleteConfirm":
    "Are you sure you want to delete this admin? The admin will not be able to login after deletion.",
  "modal.admin.editTitle": "Edit Admin",
  "modal.admin.createTitle": "Create Admin",
  "message.admin.createSuccess": "Admin account created successfully!",
  "message.admin.createSuccessExisting":
    "Created successfully! The phone number already exists, use the original password to login.",
  "form.admin.assignRoles": "Assign Roles",
  "form.admin.name": "Admin Identity Name",
  "validation.admin.rolesRequired": "Please select at least one role",
  "placeholder.admin.selectRoles": "Please select roles (multiple)",
  "placeholder.admin.name": "Please enter admin identity name",
  "table.admin.name": "Admin Name",
  "note.admin.phoneUnmodifiable":
    "Note: Phone number cannot be modified. Please use password reset feature to change password.",

  // ========== Table Management ==========
  "button.table.create": "Create Table",
  "error.table.loadListFailed": "Failed to load table list",
  "error.table.deleteFailed": "Failed to delete table",
  "error.table.operationFailed": "Table operation failed",
  "table.table.brandName": "Brand Name",
  "table.table.storeName": "Store Name",
  "table.table.storeId": "Store ID",
  "table.table.tableNo": "Table No.",
  "table.table.tableType": "Table Type",
  "table.table.status": "Status",
  "table.table.hourlyRate": "Hourly Rate",
  "table.table.deviceSn": "Device SN",
  "table.status.idle": "Idle",
  "table.status.inUse": "In Use",
  "table.status.maintenance": "Maintenance",
  "table.status.disabled": "Disabled",
  "table.tableType.snooker": "Snooker",
  "table.tableType.chineseEight": "Chinese Eight-Ball",
  "table.tableType.nineBall": "Nine-Ball",
  "modal.table.deleteTitle": "Delete Table",
  "modal.table.deleteContent": "Are you sure you want to delete this table?",
  "modal.table.updateTitle": "Edit Table",
  "modal.table.createTitle": "Create Table",
  "form.table.storeId": "Store",
  "form.table.tableNo": "Table No.",
  "form.table.tableType": "Table Type",
  "form.table.status": "Status",
  "form.table.hourlyRate": "Hourly Rate",
  "form.table.hourlyRateTooltip": "Unit: CNY/hour",
  "form.table.description": "Description",
  "validation.table.storeIdRequired": "Please select store",
  "validation.table.tableNoRequired": "Please enter table number",
  "validation.table.tableTypeRequired": "Please select table type",
  "validation.table.statusRequired": "Please select status",
  "placeholder.table.tableNo": "Please enter table number, e.g.: A001",
  "placeholder.table.hourlyRate": "Please enter hourly rate",
  "placeholder.table.description": "Please enter description",

  // ========== Device Management ==========
  "button.device.bind": "Bind Device",
  "button.device.unbind": "Unbind Store",
  "error.device.loadListFailed": "Failed to load device list",
  "error.device.bindFailed": "Failed to bind device",
  "error.device.unbindFailed": "Failed to unbind device",
  "error.device.updateFailed": "Failed to update device information",
  "message.device.bindSuccess": "Device bound successfully",
  "message.device.unbindSuccess": "Device unbound successfully",
  "message.device.unbindFailed": "Failed to unbind device",
  "message.device.updateSuccess": "Device information updated successfully",
  "message.device.noChanges": "No changes were made",
  "table.device.deviceSn": "Device SN",
  "table.device.name": "Device Name",
  "table.device.deviceType": "Device Type",
  "table.device.brandId": "Brand",
  "table.device.storeId": "Store",
  "table.device.bindStatus": "Bind Status",
  "table.device.onlineStatus": "Online Status",
  "table.device.firmwareVersion": "Firmware Version",
  "table.device.bindTime": "Bind Time",
  "table.device.lastOnlineTime": "Last Online Time",
  "deviceType.CAMERA": "Camera",
  "deviceType.HOST": "Host",
  "deviceType.SCORER": "Scorer",
  "bindStatus.UNBOUND": "Unbound",
  "bindStatus.BOUND": "Bound",
  "onlineStatus.OFFLINE": "Offline",
  "onlineStatus.ONLINE": "Online",
  "modal.device.bindTitle": "Bind Device",
  "modal.device.editTitle": "Edit Device Information",
  "modal.device.unbindTitle": "Unbind Device",
  "modal.device.unbindContent":
    "Are you sure you want to unbind this device? The device can be rebound to another store after unbinding.",
  "form.device.deviceSn": "Device SN",
  "form.device.name": "Device Name",
  "form.device.firmwareVersion": "Firmware Version",
  "form.device.brandId": "Brand",
  "form.device.storeId": "Store",
  "form.device.deviceSnRequired": "Please enter device SN",
  "form.device.brandRequired": "Please select a brand",
  "form.device.storeRequired": "Please select a store",
  "form.device.deviceSnPlaceholder": "Please enter device SN",
  "form.device.namePlaceholder": "Please enter device name (optional)",
  "form.device.brandPlaceholder": "Please select a brand",
  "form.device.storePlaceholder": "Please select a store (select brand first)",
  "form.device.storeAdminBindTip":
    "Device will be automatically bound to your brand and store",
  "validation.device.nameRequired": "Please enter device name",

  // Device bind/unbind table
  "button.device.bindTable": "Bind Table",
  "button.device.unbindTable": "Unbind Table",
  "message.device.bindTableSuccess": "Device bound to table successfully",
  "message.device.bindTableFailed": "Failed to bind device to table",
  "message.device.unbindTableSuccess": "Device unbound from table successfully",
  "message.device.unbindTableFailed": "Failed to unbind device from table",
  "message.device.notFound": "Device not found",
  "error.device.bindTableFailed": "Failed to bind table",
  "error.device.unbindTableFailed": "Failed to unbind table",
  "modal.device.bindTableTitle": "Bind Table",
  "modal.device.unbindTableTitle": "Unbind Table",
  "modal.device.unbindTableContent":
    "Are you sure you want to unbind the device from the table? The device will remain bound to the store and can be rebound to another table.",
  "table.device.tableNo": "Table No",
  "form.device.deviceInfo": "Device Information",
  "form.device.storeName": "Store",
  "form.device.tableId": "Table",
  "form.device.tableRequired": "Please select a table",
  "form.device.tablePlaceholder": "Please select a table",

  // Device online logs
  "button.device.onlineLogs": "Online Logs",
  "button.device.syncOnlineStatus": "Sync Status",
  "modal.device.onlineLogsTitle": "Device Online Logs",
  "error.device.loadOnlineLogsFailed": "Failed to load online logs",
  "message.device.syncingOnlineStatus": "Syncing device online status...",
  "message.device.syncOnlineStatusSuccess":
    "Device online status synced successfully",
  "error.device.syncOnlineStatusFailed": "Failed to sync device online status",
  "table.deviceOnlineLog.eventType": "Event Type",
  "table.deviceOnlineLog.clientIp": "Client IP",
  "table.deviceOnlineLog.eventTime": "Event Time",
  "eventType.ONLINE": "Online",
  "eventType.OFFLINE": "Offline",

  // Device bind open app
  "button.device.bindOpenApp": "Bind App",
  "button.device.rebindOpenApp": "Change App",
  "button.device.unbindOpenApp": "Unbind App",
  "message.device.bindOpenAppSuccess": "Device bound to open app successfully",
  "message.device.unbindOpenAppSuccess":
    "Device unbound from open app successfully",
  "error.device.bindOpenAppFailed": "Failed to bind open app",
  "error.device.unbindOpenAppFailed": "Failed to unbind open app",
  "modal.device.bindOpenAppTitle": "Bind Open App",
  "modal.device.unbindOpenAppTitle": "Unbind Open App",
  "modal.device.unbindOpenAppContent":
    "Are you sure to unbind the open app? Device data will no longer be pushed to third-party systems.",
  "table.device.openApp": "Open App",
  "form.device.openAppId": "Open App",
  "form.device.openAppRequired": "Please select an open app",
  "form.device.openAppPlaceholder": "Please select an open app",

  // Scoreboard Management
  "button.device.createScoreboard": "Create Scoreboard",
  "button.device.deleteScoreboard": "Delete Scoreboard",
  "button.device.viewScoreboardCode": "View Code",
  "modal.device.createScoreboardTitle": "Create Scoreboard",
  "modal.device.deleteScoreboardTitle": "Delete Scoreboard",
  "modal.device.deleteScoreboardContent":
    'Are you sure to delete scoreboard "{name}"? This action cannot be undone.',
  "message.device.createScoreboardSuccess": "Scoreboard created successfully",
  "message.device.deleteScoreboardSuccess": "Scoreboard deleted successfully",
  "message.device.unbindTableBeforeDelete":
    "Please unbind the table before deleting the scoreboard",
  "error.device.createScoreboardFailed": "Failed to create scoreboard",
  "error.device.deleteScoreboardFailed": "Failed to delete scoreboard",

  // ========== Scoreboard Code Management ==========
  "pages.scoreboardCode.generateCode": "Generate Code",
  "pages.scoreboardCode.viewCode": "View Code",
  "pages.scoreboardCode.deleteCode": "Delete Code",
  "pages.scoreboardCode.copyUrl": "Copy URL",
  "pages.scoreboardCode.copySuccess": "URL copied to clipboard",
  "pages.scoreboardCode.copyFailed": "Copy failed",

  // Table columns
  "table.scoreboardCode.code": "Code",
  "table.scoreboardCode.deviceSn": "Device SN",
  "table.scoreboardCode.deviceName": "Device Name",
  "table.scoreboardCode.brandName": "Brand",
  "table.scoreboardCode.storeName": "Store",
  "table.scoreboardCode.url": "Scoreboard URL",
  "table.scoreboardCode.expireAt": "Expire At",
  "table.scoreboardCode.createdAt": "Created At",
  "table.scoreboardCode.status": "Status",
  "table.scoreboardCode.status.enabled": "Enabled",
  "table.scoreboardCode.status.disabled": "Disabled",
  "table.scoreboardCode.status.expired": "Expired",
  "table.scoreboardCode.status.valid": "Valid",
  "table.scoreboardCode.displayConfig": "Display Config",
  "table.scoreboardCode.displayConfig.configured": "Configured",
  "table.scoreboardCode.displayConfig.empty": "Empty",
  "table.scoreboardCode.expireStatus": "Expire Status",
  "table.scoreboardCode.expireStatus.valid": "Valid",
  "table.scoreboardCode.expireStatus.expired": "Expired",

  // Buttons
  "button.scoreboardCode.generate": "Generate Code",
  "button.scoreboardCode.delete": "Delete",
  "button.scoreboardCode.view": "View",
  "button.scoreboardCode.copy": "Copy URL",
  "button.scoreboardCode.enable": "Enable",
  "button.scoreboardCode.disable": "Disable",

  // Messages
  "message.scoreboardCode.generateSuccess": "Code generated successfully",
  "message.scoreboardCode.deleteSuccess": "Code deleted successfully",
  "message.scoreboardCode.updateStatusSuccess": "Status updated successfully",
  "error.scoreboardCode.generateFailed": "Failed to generate code",
  "error.scoreboardCode.deleteFailed": "Failed to delete code",
  "error.scoreboardCode.loadListFailed": "Failed to load code list",
  "error.scoreboardCode.updateStatusFailed": "Failed to update status",

  // Form
  "form.scoreboardCode.deviceId": "Select Device",
  "form.scoreboardCode.deviceIdRequired": "Please select a device",
  "form.scoreboardCode.deviceIdPlaceholder": "Please select a device",
  "form.scoreboardCode.expireHours": "Expire Duration",
  "form.scoreboardCode.expireHoursRequired": "Please enter expire duration",
  "form.scoreboardCode.expireHoursPlaceholder":
    "Default 24 hours, minimum 1 hour",
  "form.scoreboardCode.expireHoursMin": "Minimum 1 hour",
  "form.scoreboardCode.displayConfig": "Display Config",
  "form.scoreboardCode.eventName": "Event Name",
  "form.scoreboardCode.eventNamePlaceholder": "Please enter event name",
  "form.scoreboardCode.raceTo": "Race To",
  "form.scoreboardCode.scoreBarSkin": "Score Bar Skin",
  "form.scoreboardCode.scoreBarSkin.broadcast": "Broadcast",
  "form.scoreboardCode.scoreBarSkin.classic": "Classic",
  "form.scoreboardCode.players": "Players",
  "form.scoreboardCode.homePlayer": "Player A",
  "form.scoreboardCode.awayPlayer": "Player B",
  "form.scoreboardCode.playerName": "Player Name",
  "form.scoreboardCode.nationality": "Nationality",
  "form.scoreboardCode.nationalityPlaceholder": "Select nationality",
  "form.scoreboardCode.homePlayerName": "Player A - Player Name",
  "form.scoreboardCode.homePlayerNationality": "Player A - Nationality",
  "form.scoreboardCode.homePlayerImageUrl": "Player A Avatar",
  "form.scoreboardCode.awayPlayerName": "Player B - Player Name",
  "form.scoreboardCode.awayPlayerNationality": "Player B - Nationality",
  "form.scoreboardCode.awayPlayerImageUrl": "Player B Avatar",
  "form.scoreboardCode.playerNamePlaceholder": "Enter player name",

  // Modal
  "modal.scoreboardCode.generateTitle": "Generate Scoreboard Code",
  "modal.scoreboardCode.viewTitle": "Scoreboard Code Details",
  "modal.scoreboardCode.deleteTitle": "Delete Scoreboard Code",
  "modal.scoreboardCode.deleteContent":
    "Are you sure to delete this code? The code will be invalid after deletion, but it will not affect the connected scoreboard.",
  "modal.scoreboardCode.disableTitle": "Disable Scoreboard Code",
  "modal.scoreboardCode.disableContent":
    "Are you sure to disable this code? The scoreboard will not be able to connect using this code after disabling.",
  "modal.scoreboardCode.deviceInfo": "Device Information",
  "modal.scoreboardCode.codeInfo": "Code Information",
  "modal.scoreboardCode.code": "Code",
  "modal.scoreboardCode.url": "Scoreboard URL",
  "modal.scoreboardCode.expireAt": "Expire At",
  "modal.scoreboardCode.shareTip":
    "You can share the following link with the streamer, who can open the link to connect to the scoreboard",

  // Filter
  "filter.scoreboardCode.includeExpired": "Include Expired",

  // Switch admin role
  "pages.switchAdmin.modalTitle": "Switch Admin Role",
  "pages.switchAdmin.adminName": "Role Name",
  "pages.switchAdmin.adminTypeLabel": "Role Type",
  "pages.switchAdmin.currentRole": "Current Role",
  "pages.switchAdmin.selectRole": "Select a role to switch",
  "pages.switchAdmin.switchSuccess": "Switch role successfully",
  "pages.switchAdmin.switchFailed": "Failed to switch role",
  "pages.switchAdmin.loading": "Loading...",
  "pages.switchAdmin.adminType.platform": "Platform Admin",
  "pages.switchAdmin.adminType.brand": "Brand Admin",
  "pages.switchAdmin.adminType.store": "Store Admin",
  "pages.switchAdmin.adminType.fund": "Fund Account",
  "pages.switchAdmin.brand": "Brand",
  "pages.switchAdmin.store": "Store",
  "pages.switchAdmin.noAdmins": "No other roles available",

  // ========== Coach Management ==========
  "error.coach.loadListFailed": "Failed to load coach list",
  "error.coach.deleteFailed": "Failed to delete coach",
  "error.coach.operationFailed": "Coach operation failed",
  "table.coach.coachInfo": "Coach Info",
  "table.coach.phone": "Phone",
  "table.coach.gender": "Gender",
  "table.coach.billingMode": "Billing Mode",
  "table.coach.serviceStatus": "Service Status",
  "table.coach.serviceStats": "Service Statistics",
  "gender.female": "Female",
  "gender.male": "Male",
  "billingMode.hourly": "Hourly Rate",
  "billingMode.perTime": "Per Session",
  "time.minutes": "mins",
  "time.perSession": "session",
  "time.hours": "hrs",
  "serviceStatus.idle": "Idle",
  "serviceStatus.busy": "Busy",
  "stats.count": "Count",
  "stats.duration": "Duration",
  "modal.coach.deleteTitle": "Delete Coach",
  "modal.coach.deleteBusyContent":
    "The coach is currently serving. Are you sure you want to delete?",
  "modal.coach.deleteContent": "Are you sure you want to delete this coach?",
  "button.coach.create": "Create Coach",
  "modal.coach.updateTitle": "Edit Coach",
  "modal.coach.createTitle": "Create Coach",
  "form.coach.name": "Coach Name",
  "form.coach.phone": "Phone",
  "form.coach.avatar": "Avatar",
  "form.coach.gender": "Gender",
  "form.coach.billingMode": "Billing Mode",
  "form.coach.serviceFee": "Service Fee",
  "form.coach.serviceFeeTooltip":
    "Amount in yuan, supports up to 2 decimal places",
  "form.coach.billingDuration": "Billing Duration",
  "form.coach.billingDurationTooltip": "Duration unit for hourly billing",
  "form.coach.introduction": "Introduction",
  "validation.coach.nameRequired": "Please enter coach name",
  "validation.coach.phoneRequired": "Please enter phone number",
  "validation.coach.billingModeRequired": "Please select billing mode",
  "validation.coach.serviceFeeRequired": "Please enter service fee",
  "validation.coach.billingDurationRequired":
    "Billing duration is required for hourly rate",
  "placeholder.coach.name": "Enter coach name",
  "placeholder.coach.billingMode": "Select billing mode",
  "placeholder.coach.serviceFee": "Enter service fee",
  "placeholder.coach.billingDuration": "Enter billing duration",
  "placeholder.coach.introduction": "Enter introduction",

  // ========== Product Category ==========
  "error.productCategory.loadListFailed": "Failed to load category list",
  "error.productCategory.deleteFailed": "Failed to delete category",
  "error.productCategory.operationFailed": "Category operation failed",
  "error.productCategory.loadFailed": "Failed to load categories",
  "table.productCategory.name": "Category Name",
  "table.productCategory.icon": "Category Icon",
  "modal.productCategory.deleteTitle": "Delete Category",
  "modal.productCategory.deleteContent":
    "Are you sure you want to delete this category?",
  "button.productCategory.create": "Create Category",
  "modal.productCategory.updateTitle": "Edit Category",
  "modal.productCategory.createTitle": "Create Category",
  "form.productCategory.name": "Category Name",
  "form.productCategory.icon": "Category Icon",
  "validation.productCategory.nameRequired": "Please enter category name",
  "placeholder.productCategory.name": "Enter category name",

  // ========== Product Management ==========
  "error.product.loadListFailed": "Failed to load product list",
  "error.product.deleteFailed": "Failed to delete product",
  "error.product.operationFailed": "Product operation failed",
  "table.product.categoryId": "Category",
  "table.product.name": "Product Name",
  "table.product.barcode": "Barcode",
  "table.product.image": "Image",
  "table.product.price": "Price (¥)",
  "table.product.stock": "Stock",
  "table.product.unit": "Unit",
  "product.stock.unlimited": "Unlimited",
  "product.status.onSale": "On Sale",
  "product.status.offSale": "Off Sale",
  "modal.product.deleteTitle": "Delete Product",
  "modal.product.deleteContent":
    "Are you sure you want to delete this product?",
  "button.product.create": "Create Product",
  "modal.product.updateTitle": "Edit Product",
  "modal.product.createTitle": "Create Product",
  "form.product.categoryId": "Category",
  "form.product.name": "Product Name",
  "form.product.barcode": "Barcode",
  "form.product.price": "Price",
  "form.product.unit": "Unit",
  "form.product.stock": "Stock",
  "form.product.stockTooltip": "Enter -1 for unlimited stock",
  "form.product.image": "Image",
  "form.product.description": "Description",
  "validation.product.nameRequired": "Please enter product name",
  "validation.product.priceRequired": "Please enter price",
  "validation.product.stockRequired": "Please enter stock",
  "placeholder.product.categoryId": "Select category",
  "placeholder.product.name": "Enter product name",
  "placeholder.product.barcode": "Enter barcode",
  "placeholder.product.price": "Enter price",
  "placeholder.product.unit": "Enter unit (e.g., piece, item, serving)",
  "placeholder.product.stock": "Enter stock quantity",
  "placeholder.product.description": "Enter description",
  "currency.yuan": "CNY",

  // ========== Common ==========
  "form.common.sortOrderTooltip": "Lower numbers appear first",
  "placeholder.common.sortOrder": "Enter sort order",

  // ========== Open Platform App Management ==========
  "button.openApp.create": "Create App",
  "button.openApp.resetSecret": "Reset Secret",
  "error.openApp.loadListFailed": "Failed to load app list",
  "error.openApp.deleteFailed": "Failed to delete app",
  "error.openApp.operationFailed": "App operation failed",
  "error.openApp.resetSecretFailed": "Failed to reset secret",
  "table.openApp.appName": "App Name",
  "table.openApp.appId": "App ID",
  "table.openApp.appType": "App Type",
  "table.openApp.brandName": "Brand Name",
  "table.openApp.storeName": "Store Name",
  "table.openApp.rateLimit": "Rate Limit",
  "table.openApp.callbackUrl": "Callback URL",
  "table.openApp.description": "Description",
  "appType.brand": "Brand App",
  "appType.store": "Store App",
  "modal.openApp.deleteTitle": "Delete App",
  "modal.openApp.deleteContent":
    "Are you sure you want to delete this app? The app secret will be invalidated immediately after deletion.",
  "modal.openApp.updateTitle": "Edit App",
  "modal.openApp.createTitle": "Create App",
  "modal.openApp.resetSecretTitle": "Reset App Secret",
  "modal.openApp.resetSecretContent":
    "Are you sure you want to reset the app secret? The old secret will be invalidated immediately, and third-party systems using this app will need to update their configuration.",
  "message.openApp.createSuccess": "App created successfully!",
  "message.openApp.createSuccessDetail":
    "App has been created successfully. Below is the app secret information, please keep it safe:",
  "message.openApp.secretWarning":
    "Warning: App secret is shown only once, please save it immediately!",
  "message.openApp.resetSecretSuccess": "Secret reset successfully!",
  "message.openApp.resetSecretDetail":
    "New secret is as follows, please keep it safe:",
  "form.openApp.appName": "App Name",
  "form.openApp.appType": "App Type",
  "form.openApp.brandId": "Brand",
  "form.openApp.storeId": "Store",
  "form.openApp.rateLimit": "Rate Limit",
  "form.openApp.rateLimitTooltip": "Maximum calls per minute",
  "form.openApp.callbackUrl": "Callback URL",
  "form.openApp.description": "Description",
  "validation.openApp.appNameRequired": "Please enter app name",
  "validation.openApp.appTypeRequired": "Please select app type",
  "validation.openApp.brandIdRequired": "Please select brand",
  "validation.openApp.storeIdRequired": "Store app must select a store",
  "placeholder.openApp.appName": "Please enter app name",
  "placeholder.openApp.appType": "Please select app type",
  "placeholder.openApp.brandId": "Please select brand",
  "placeholder.openApp.storeId": "Please select store (required for store app)",
  "placeholder.openApp.rateLimit": "Please enter rate limit",
  "placeholder.openApp.callbackUrl": "Please enter callback URL",
  "placeholder.openApp.description": "Please enter description",
  "label.openApp.appId": "App ID",
  "label.openApp.appSecret": "App Secret",
  "unit.perMinute": "calls/min",

  // ========== Order Management ==========
  "error.order.loadListFailed": "Failed to load order list",
  "table.order.orderNo": "Order No.",
  "table.order.orderType": "Order Type",
  "table.order.storeName": "Store Name",
  "table.order.storeId": "Store",
  "table.order.tableNo": "Table No.",
  "table.order.totalAmount": "Order Amount",
  "table.order.mergedAmount": "Total Amount",
  "table.order.orderStatus": "Order Status",
  "table.order.payStatus": "Payment Status",
  "table.order.operatorName": "Operator",
  "orderType.table": "Table Order",
  "orderType.retail": "Retail Order",
  "orderType.coach": "Coach Order",
  "orderStatus.pending": "Pending",
  "orderStatus.inProgress": "In Progress",
  "orderStatus.completed": "Completed",
  "orderStatus.cancelled": "Cancelled",
  "orderStatus.refunded": "Refunded",
  "payStatus.unpaid": "Unpaid",
  "payStatus.paying": "Paying",
  "payStatus.paid": "Paid",
  "payStatus.refunding": "Refunding",
  "payStatus.refunded": "Refunded",
  "payStatus.partialRefunded": "Partial Refund",
  "button.order.viewDetail": "View",
  "modal.order.detailTitle": "Order Detail",
  "detail.order.tableType": "Table Type",
  "detail.order.billingMode": "Billing Mode",
  "detail.order.hourlyRate": "Hourly Rate",
  "detail.order.startTime": "Start Time",
  "detail.order.endTime": "End Time",
  "detail.order.actualDuration": "Actual Duration",
  "detail.order.tableAmount": "Table Fee",
  "detail.order.discountAmount": "Discount",
  "detail.order.payAmount": "Paid Amount",
  "detail.order.paidAt": "Paid At",
  "detail.order.remark": "Remark",
  "detail.order.subOrders": "Sub Orders",
  // Product Info
  "detail.order.itemList": "Product List",
  "detail.order.productImage": "Image",
  "detail.order.productName": "Product Name",
  "detail.order.productPrice": "Unit Price",
  "detail.order.quantity": "Quantity",
  "detail.order.subtotal": "Subtotal",
  // Coach Info
  "detail.order.coachList": "Coach List",
  "detail.order.coachAvatar": "Avatar",
  "detail.order.coachName": "Coach Name",
  "detail.order.coachBillingMode": "Billing Mode",
  "detail.order.serviceFee": "Service Fee",
  "detail.order.coachServiceStatus": "Service Status",
  "detail.order.coachSubtotal": "Subtotal",
  "detail.order.operatorName": "Operator",

  // ========== Common: Yes/No ==========
  "common.yes": "Yes",
  "common.no": "No",
  "common.configured": "Configured",
  "common.notConfigured": "Not Configured",

  // ========== WeChat SP Config ==========
  "button.wechatSpConfig.create": "Create SP Config",
  "modal.wechatSpConfig.deleteTitle": "Delete SP Config",
  "modal.wechatSpConfig.deleteContent":
    "Are you sure you want to delete this SP config? Payment functions will be disabled after deletion.",
  "modal.wechatSpConfig.updateTitle": "Edit SP Config",
  "modal.wechatSpConfig.createTitle": "Create SP Config",
  "table.wechatSpConfig.brandName": "Brand Name",
  "table.wechatSpConfig.brandId": "Brand",
  "table.wechatSpConfig.spMchid": "SP Merchant ID",
  "table.wechatSpConfig.spAppid": "SP AppID",
  "table.wechatSpConfig.serialNo": "API Cert Serial No",
  "table.wechatSpConfig.hasApiKeyV2": "API v2 Key",
  "table.wechatSpConfig.hasCertContent": "API Cert",
  "form.wechatSpConfig.brandId": "Brand",
  "form.wechatSpConfig.spMchid": "SP Merchant ID",
  "form.wechatSpConfig.spAppid": "SP AppID",
  "form.wechatSpConfig.serialNo": "API Cert Serial No",
  "form.wechatSpConfig.apiKeyV2": "API v2 Key",
  "form.wechatSpConfig.apiKeyV2Tooltip":
    "32-character API v2 key for payment code",
  "form.wechatSpConfig.apiKeyV3": "API v3 Key",
  "form.wechatSpConfig.privateKey": "API Private Key",
  "form.wechatSpConfig.privateKeyTooltip": "PEM format API private key",
  "form.wechatSpConfig.certContent": "API Cert Content",
  "form.wechatSpConfig.certContentTooltip":
    "API certificate content for v2 API",
  "form.wechatSpConfig.configuredPlaceholder":
    "Configured, leave empty to keep unchanged",
  "validation.wechatSpConfig.brandIdRequired": "Please select brand",
  "validation.wechatSpConfig.spMchidRequired": "Please enter SP merchant ID",
  "validation.wechatSpConfig.spAppidRequired": "Please enter SP AppID",
  "validation.wechatSpConfig.serialNoRequired":
    "Please enter API cert serial number",
  "validation.wechatSpConfig.apiKeyV3Required": "Please enter API v3 key",
  "validation.wechatSpConfig.privateKeyRequired":
    "Please enter API private key",

  // ========== Alipay SP Config ==========
  "button.alipaySpConfig.create": "Create Alipay SP Config",
  "modal.alipaySpConfig.deleteTitle": "Delete Alipay SP Config",
  "modal.alipaySpConfig.deleteContent":
    "Are you sure you want to delete this Alipay SP config? Payment functions will be disabled after deletion.",
  "modal.alipaySpConfig.updateTitle": "Edit Alipay SP Config",
  "modal.alipaySpConfig.createTitle": "Create Alipay SP Config",
  "table.alipaySpConfig.brandId": "Brand",
  "table.alipaySpConfig.brandName": "Brand Name",
  "table.alipaySpConfig.appId": "App ID",
  "table.alipaySpConfig.configured": "Config Status",
  "form.alipaySpConfig.brandId": "Brand",
  "form.alipaySpConfig.appId": "App ID",
  "form.alipaySpConfig.serviceProviderId": "Service Provider ID",
  "form.alipaySpConfig.serviceProviderIdTooltip":
    "Service Provider ID for commission calculation. Fill in this field if you are an Alipay service provider to receive transaction commissions. Non-service providers can leave it blank.",
  "form.alipaySpConfig.privateKey": "App Private Key",
  "form.alipaySpConfig.privateKeyTooltip":
    "App private key for generating request signature",
  "form.alipaySpConfig.appCertContent": "App Public Cert Content",
  "form.alipaySpConfig.appCertContentTooltip":
    "App public certificate content (.crt file), complete PEM format",
  "form.alipaySpConfig.alipayCertContent": "Alipay Public Cert Content",
  "form.alipaySpConfig.alipayCertContentTooltip":
    "Alipay public certificate (alipayCertPublicKey_RSA2.crt), complete PEM format",
  "form.alipaySpConfig.alipayRootCertContent": "Alipay Root Cert Content",
  "form.alipaySpConfig.alipayRootCertContentTooltip":
    "Alipay root certificate (alipayRootCert.crt), complete PEM format",
  "form.alipaySpConfig.encryptKey": "Encrypt Key",
  "form.alipaySpConfig.encryptKeyTooltip":
    "AES encryption key for sensitive data (optional)",
  "form.alipaySpConfig.configuredPlaceholder":
    "Configured, leave empty to keep unchanged",
  "validation.alipaySpConfig.brandIdRequired": "Please select brand",
  "validation.alipaySpConfig.appIdRequired": "Please enter app ID",
  "validation.alipaySpConfig.privateKeyRequired":
    "Please enter app private key",
  "validation.alipaySpConfig.appCertContentRequired":
    "Please enter app public cert content",
  "validation.alipaySpConfig.alipayCertContentRequired":
    "Please enter Alipay public cert content",
  "validation.alipaySpConfig.alipayRootCertContentRequired":
    "Please enter Alipay root cert content",

  // ========== Sub Merchant Config ==========
  "button.subMerchant.create": "Create Sub Merchant",
  "modal.subMerchant.deleteTitle": "Delete Sub Merchant",
  "modal.subMerchant.deleteContent":
    "Are you sure you want to delete this sub merchant config? Payment functions will be disabled for this store.",
  "modal.subMerchant.updateTitle": "Edit Sub Merchant",
  "modal.subMerchant.createTitle": "Create Sub Merchant",
  "modal.subMerchant.configTitle": "{storeName} - Merchant Config",
  "table.subMerchant.brandName": "Brand Name",
  "table.subMerchant.brandId": "Brand",
  "table.subMerchant.storeName": "Store Name",
  "table.subMerchant.storeId": "Store",
  "table.subMerchant.wxSubMchid": "WeChat Sub Mchid",
  "table.subMerchant.wxSubAppid": "WeChat Sub AppID",
  "table.subMerchant.wxFeeRate": "WeChat Fee Rate",
  "table.subMerchant.wxProfitSharingCap": "WeChat Sharing Cap",
  "table.subMerchant.aliUserId": "Alipay User ID",
  "table.subMerchant.aliAuthorized": "Alipay Auth Status",
  "table.subMerchant.aliFeeRate": "Alipay Fee Rate",
  "table.subMerchant.aliProfitSharingCap": "Alipay Sharing Cap",
  "form.subMerchant.brandId": "Brand",
  "form.subMerchant.storeId": "Store",
  "form.subMerchant.wechatConfig": "WeChat Pay Config",
  "form.subMerchant.alipayConfig": "Alipay Config",
  "form.subMerchant.wxSubMchid": "Sub Merchant ID",
  "form.subMerchant.wxSubAppid": "Sub Merchant AppID",
  "form.subMerchant.wxFeeRate": "Fee Rate",
  "form.subMerchant.wxProfitSharingCap": "Sharing Cap",
  "form.subMerchant.aliUserId": "Alipay User ID",
  "form.subMerchant.aliUserIdTooltip":
    "Alipay user ID of the authorized merchant, e.g.: 2088123456789012",
  "form.subMerchant.aliAppAuthToken": "Alipay Auth Token",
  "form.subMerchant.aliAppAuthTokenTooltip":
    "The app_auth_token obtained after merchant authorization, permanently valid. Format: 202312BB1234567890abcdef...",
  "form.subMerchant.aliFeeRate": "Fee Rate",
  "form.subMerchant.aliProfitSharingCap": "Sharing Cap",
  "validation.subMerchant.brandIdRequired": "Please select brand",
  "validation.subMerchant.storeIdRequired": "Please select store",

  // ========== Refund Management ==========
  "button.refund.create": "Admin Refund",
  "button.refund.approve": "Approve",
  "button.refund.sync": "Sync Status",
  "button.refund.submit": "Submit Refund",
  "button.common.view": "View",
  "error.refund.loadListFailed": "Failed to load refund list",
  "error.refund.syncFailed": "Failed to sync refund status",
  "error.refund.operationFailed": "Refund operation failed",
  "error.refund.searchFailed": "Failed to search order",
  "message.refund.createSuccess": "Refund created successfully",
  "message.refund.approveSuccess": "Approval successful",
  "message.refund.syncSuccess": "Status synced successfully",
  "message.refund.searchSuccess": "Order found successfully",
  "message.refund.orderNotFound": "Order not found",
  "pages.refund.createTitle": "Admin Refund",
  "pages.refund.searchOrder": "Search Order",
  "pages.refund.orderInfo": "Order Information",
  "pages.refund.refundInfo": "Refund Information",
  "table.refund.refundNo": "Refund No",
  "table.refund.orderNo": "Order No",
  "table.refund.payChannel": "Pay Channel",
  "table.refund.totalAmount": "Order Amount",
  "table.refund.refundAmount": "Refund Amount",
  "table.refund.refundType": "Refund Type",
  "table.refund.refundReason": "Refund Reason",
  "table.refund.applicantType": "Applicant Type",
  "table.refund.applicantName": "Applicant",
  "table.refund.approvalStatus": "Approval Status",
  "table.refund.refundStatus": "Refund Status",
  "modal.refund.createTitle": "Admin Refund",
  "modal.refund.approveTitle": "Refund Approval",
  "form.refund.orderId": "Order ID",
  "form.refund.refundType": "Refund Type",
  "form.refund.refundAmount": "Refund Amount",
  "form.refund.refundReason": "Refund Reason",
  "form.refund.approveAction": "Approve Action",
  "form.refund.approveRemark": "Approve Remark",
  "placeholder.refund.searchValue": "Enter order number or payment number",
  "validation.refund.orderIdRequired": "Please enter order ID",
  "validation.refund.refundTypeRequired": "Please select refund type",
  "validation.refund.refundAmountRequired": "Please enter refund amount",
  "validation.refund.approveActionRequired": "Please select approve action",
  "validation.refund.searchValueRequired":
    "Please enter order number or payment number",
  "validation.refund.orderRequired": "Please search order first",
  "validation.refund.refundReasonRequired": "Please enter refund reason",
  "enum.refundType.full": "Full Refund",
  "enum.refundType.partial": "Partial Refund",
  "enum.applicantType.user": "User",
  "enum.applicantType.store": "Store Admin",
  "enum.applicantType.brand": "Brand Admin",
  "enum.applicantType.platform": "Platform Admin",
  "enum.approvalStatus.pending": "Pending",
  "enum.approvalStatus.autoApproved": "Auto Approved",
  "enum.approvalStatus.approved": "Approved",
  "enum.approvalStatus.rejected": "Rejected",
  "enum.refundStatus.pending": "Pending",
  "enum.refundStatus.processing": "Processing",
  "enum.refundStatus.success": "Success",
  "enum.refundStatus.failed": "Failed",
  "enum.refundStatus.abnormal": "Abnormal",
  "enum.approveAction.approve": "Approve",
  "enum.approveAction.reject": "Reject",
  "enum.payChannel.wechat": "WeChat Pay",
  "enum.payChannel.alipay": "Alipay",

  // ========== Callback Logs ==========
  "error.callbackLog.loadListFailed": "Failed to load callback logs",
  "pages.callbackLog.detailTitle": "Callback Details",
  "table.callbackLog.appId": "Application",
  "table.callbackLog.matchNo": "Match Number",
  "table.callbackLog.thirdPartyMatchId": "Third Party Match ID",
  "table.callbackLog.eventType": "Event Type",
  "table.callbackLog.status": "Callback Status",
  "table.callbackLog.responseStatus": "Response Status",
  "table.callbackLog.retryCount": "Retry Count",
  "table.callbackLog.costTime": "Cost Time",
  "table.callbackLog.timestamp": "Callback Time",
  "table.callbackLog.startTime": "Start Time",
  "table.callbackLog.endTime": "End Time",
  "table.callbackLog.requestBody": "Request Body",
  "table.callbackLog.responseBody": "Response Body",
  "table.callbackLog.errorMessage": "Error Message",
  "button.common.detail": "Detail",
  "eventType.matchStart": "Match Start",
  "eventType.frameScore": "Frame Score",
  "eventType.frameEnd": "Frame End",
  "eventType.matchEnd": "Match End",
  "status.success": "Success",
  "status.failure": "Failure",

  // ========== API Logs ==========
  "error.apiLog.loadListFailed": "Failed to load API logs",
  "pages.apiLog.detailTitle": "API Call Details",
  "table.apiLog.appId": "Application",
  "table.apiLog.apiPath": "API Path",
  "table.apiLog.httpMethod": "HTTP Method",
  "table.apiLog.responseCode": "Response Code",
  "table.apiLog.requestIp": "Request IP",
  "table.apiLog.costTime": "Cost Time",
  "table.apiLog.timestamp": "Call Time",
  "table.apiLog.startTime": "Start Time",
  "table.apiLog.endTime": "End Time",
  "table.apiLog.requestParams": "Request Parameters",
  "table.apiLog.userAgent": "User-Agent",
  "table.apiLog.errorMessage": "Error Message",

  // ========== Order Revenue Statistics ==========
  "pages.statistics.orderRevenue.dateRange": "Date Range",
  "pages.statistics.orderRevenue.brand": "Brand",
  "pages.statistics.orderRevenue.store": "Store",
  "pages.statistics.orderRevenue.totalAmount": "Transaction Amount",
  "pages.statistics.orderRevenue.paidAmount": "Paid Amount",
  "pages.statistics.orderRevenue.income": "Net Income",
  "pages.statistics.orderRevenue.refundedAmount": "Refund Amount",
  "pages.statistics.orderRevenue.totalOrderCount": "Total Orders",
  "pages.statistics.orderRevenue.averageOrderAmount": "Average Order Value",
  "pages.statistics.orderRevenue.ordersByType": "Order Type Distribution",
  "pages.statistics.orderRevenue.orderType.table": "Table Orders",
  "pages.statistics.orderRevenue.orderType.retail": "Retail Orders",
  "pages.statistics.orderRevenue.orderType.coach": "Coach Orders",
  "pages.statistics.orderRevenue.chart.title": "Business Analytics",
  "pages.statistics.orderRevenue.chart.amount": "Transaction Amount",
  "pages.statistics.orderRevenue.chart.orderCount": "Order Count",
  "pages.statistics.orderRevenue.chart.unit.orders": "Orders",
};
